/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';

/**
 * 
 * @export
 * @interface ContactUploadRequest
 */
export interface ContactUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactUploadRequest
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUploadRequest
     */
    sourceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactUploadRequest
     */
    isInbound?: boolean;
    /**
     * 
     * @type {Array<ParticipantRole>}
     * @memberof ContactUploadRequest
     */
    channelRoleMapping?: Array<ParticipantRole>;
    /**
     * 
     * @type {Date}
     * @memberof ContactUploadRequest
     */
    dateStarted?: Date;
    /**
     * 
     * @type {number}
     * @memberof ContactUploadRequest
     */
    agentId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactUploadRequest
     */
    agentFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUploadRequest
     */
    agentLastName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContactUploadRequest
     */
    dateTransferred?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContactUploadRequest
     */
    customerPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUploadRequest
     */
    systemPhoneNumber?: string;
}

/**
 * Check if a given object implements the ContactUploadRequest interface.
 */
export function instanceOfContactUploadRequest(value: object): boolean {
    return true;
}

export function ContactUploadRequestFromJSON(json: any): ContactUploadRequest {
    return ContactUploadRequestFromJSONTyped(json, false);
}

export function ContactUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'isInbound': json['isInbound'] == null ? undefined : json['isInbound'],
        'channelRoleMapping': json['channelRoleMapping'] == null ? undefined : ((json['channelRoleMapping'] as Array<any>).map(ParticipantRoleFromJSON)),
        'dateStarted': json['dateStarted'] == null ? undefined : (new Date(json['dateStarted'])),
        'agentId': json['agentId'] == null ? undefined : json['agentId'],
        'agentFirstName': json['agentFirstName'] == null ? undefined : json['agentFirstName'],
        'agentLastName': json['agentLastName'] == null ? undefined : json['agentLastName'],
        'dateTransferred': json['dateTransferred'] == null ? undefined : (new Date(json['dateTransferred'])),
        'customerPhoneNumber': json['customerPhoneNumber'] == null ? undefined : json['customerPhoneNumber'],
        'systemPhoneNumber': json['systemPhoneNumber'] == null ? undefined : json['systemPhoneNumber'],
    };
}

export function ContactUploadRequestToJSON(value?: ContactUploadRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fileName': value['fileName'],
        'sourceId': value['sourceId'],
        'isInbound': value['isInbound'],
        'channelRoleMapping': value['channelRoleMapping'] == null ? undefined : ((value['channelRoleMapping'] as Array<any>).map(ParticipantRoleToJSON)),
        'dateStarted': value['dateStarted'] == null ? undefined : ((value['dateStarted']).toISOString()),
        'agentId': value['agentId'],
        'agentFirstName': value['agentFirstName'],
        'agentLastName': value['agentLastName'],
        'dateTransferred': value['dateTransferred'] == null ? undefined : ((value['dateTransferred']).toISOString()),
        'customerPhoneNumber': value['customerPhoneNumber'],
        'systemPhoneNumber': value['systemPhoneNumber'],
    };
}

